import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DataService from '../../services/data.service';
import { Helmet } from 'react-helmet';

const SeoPageDisplay = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchPage();
  }, [slug]);

  const fetchPage = async () => {
    try {
      setLoading(true);
      const response = await DataService.getSeoPageBySlug(slug);
      console.log('SEO Page Response:', response.data);

      if (response.data && response.data.status === 'published') {
        setPage(response.data);
      } else if (response.data && response.data.status === 'draft') {
        setError('This page is currently in draft mode and not published yet.');
      } else {
        setError('Page not found or not published.');
      }
    } catch (err) {
      console.error('SEO Page Error:', err.response?.data || err.message);
      setError(err.response?.data?.error || 'Page not found.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 text-center">
              <p>Loading...</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error || !page) {
    return (
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 text-center">
              <h2>Page Not Found</h2>
              <p>{error || 'The page you are looking for does not exist.'}</p>
              <button className="btn btn-primary" onClick={() => navigate('/')}>
                Go to Home
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <Helmet>
        <title>{page.meta_title || page.title}</title>
        <meta name="description" content={page.meta_description || ''} />
        <meta name="keywords" content={page.meta_keywords || ''} />
        <link rel="canonical" href={`https://www.divineblushbeauty.ca/${page.slug}`} />
      </Helmet>

      <section
        style={{
          background: 'linear-gradient(135deg, #ffc1e3 0%, #ffb3d9 50%, #ffa6d0 100%)',
          paddingTop: '120px',
          paddingBottom: '80px',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Decorative circles */}
        <div style={{
          position: 'absolute',
          width: '200px',
          height: '200px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.15)',
          top: '-50px',
          right: '10%',
          zIndex: 1
        }} />
        <div style={{
          position: 'absolute',
          width: '150px',
          height: '150px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.15)',
          bottom: '-30px',
          left: '5%',
          zIndex: 1
        }} />

        <div className="container" style={{ position: 'relative', zIndex: 10 }}>
          <div className="row">
            <div className="col-md-12 text-center">
              {/* Main Title */}
              <h1 style={{
                color: 'white',
                fontSize: '48px',
                fontWeight: '700',
                marginBottom: '20px',
                lineHeight: '1.2'
              }}>
                {page.title}
              </h1>

              {/* Description */}
              {page.meta_description && (
                <p style={{
                  color: 'white',
                  fontSize: '18px',
                  lineHeight: '1.6',
                  maxWidth: '700px',
                  margin: '0 auto',
                  opacity: 0.8
                }}>
                  {page.meta_description}
                </p>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center mb-5 pb-2">
            <div className="col-md-10">
              <h2 className="mb-4" style={{ color: '#d4406f', fontWeight: 'bold' }}>
                {page.title}
              </h2>
              <div
                className="seo-page-content"
                dangerouslySetInnerHTML={{ __html: page.content }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SeoPageDisplay;
